module.exports = __webpack_public_path__ + "img/10-real-name-level.601b64b9.png";